export enum KnownError {
  NotFound = 'not-found',
  Timeout = 'timeout',
  InternalServerError = 'internal-server-error',
  UserAlreadyExists = 'user-already-exists',
  UserNotVerified = 'user-not-verified',
  InvalidCredentials = 'invalid-credentials',
  CommonPassword = 'common-password',
  INVALID_MAIL = 'INVALID_MAIL',
  INVALID_REQUEST = 'INVALID_REQUEST',
  // RFC 6749 §5.2 token-endpoint error codes.
  INVALID_GRANT = 'invalid_grant',
  INVALID_CLIENT = 'invalid_client',
  INVALID_SCOPE = 'invalid_scope',
  UNSUPPORTED_GRANT_TYPE = 'unsupported_grant_type',
  UNAUTHORIZED_CLIENT = 'unauthorized_client',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  INVALID_TOKEN = 'INVALID_TOKEN',
  MISSING_TOKEN = 'MISSING_TOKEN',
  VERIFICATION_INVALID = 'VERIFICATION_INVALID',
  NOT_ALLOWED = 'NOT_ALLOWED',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  INVALID_FIELD_VALUE = 'INVALID_FIELD_VALUE',
  INVALID_FILE_TYPE = 'INVALID_FILE_TYPE',
  FORBIDDEN = 'FORBIDDEN',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  WorkspaceAlreadyExists = 'workspaceAlreadyExists',
  NoPermissions = 'noPermissions',
  RemoveMembersFirst = 'removeMembersFirst',
  UserAlreadyInBuiltInGroup = 'userAlreadyInBuiltInGroup',
  NoRemoveAdmin = 'noRemoveAdmin',
  InvalidSettingName = 'InvalidSettingName',
  TwoFactorRequired = 'twoFactorRequired',
  TwoFactorAlreadyEnabled = 'twoFactorAlreadyEnabled',
  InvalidTwoFactorCode = 'InvalidTwoFactorCode',
  PropertyTypeMismatch = 'propertyTypeMismatch',
  PropertyIsMissingForeignPropertyId = 'propertyIsMissingForeignPropertyId',
  RequestingEntityInvalid = 'requestingEntityInvalid',
  INVALID_CAPTCHA = 'INVALID_CAPTCHA',
  AutomationVersionStatusInvalid = 'automationVersionStatusInvalid',
  AutomationError = 'automationError',
  TestException = 'testException',
  LabelInUse = 'labelInUse',
  StatusInUse = 'statusInUse',
  MultipleLabelsInUse = 'multipleLabelsInUse',
  ChartTooManyItems = 'chartTooManyItems',
  ChartTooManyUniqueCategories = 'chartTooManyUniqueCategories',
  ChartTooManyUniqueStackKeys = 'chartTooManyUniqueStackKeys',
  ChartTooManyDateRangeLabels = 'chartTooManyDateRangeLabels',
  ChartTooManyDataPoints = 'chartTooManyDataPoints',
  ChartTooManyDatasets = 'chartTooManyDatasets',
  ChartAggregationTimeout = 'chartAggregationTimeout',
  ChartInvalidValueFieldAggregation = 'chartInvalidValueFieldAggregation',
  ChartInvalidValueFieldColor = 'chartInvalidValueFieldColor',
  ChartInvalidValueFieldPosition = 'chartInvalidValueFieldPosition',
  POLICY_LIMIT_EXCEEDED = 'policy-limit-exceeded',
  PLAN_FEATURE_NOT_ENTITLED = 'plan-feature-not-entitled',
  WORKSPACE_SUSPENDED = 'workspace-suspended',
  WORKSPACE_SUBSCRIPTION_REQUIRED = 'workspace-subscription-required',
  CollectionItemAlreadyExists = 'collectionItemAlreadyExists',
  ButtonExecutionLimitReached = 'buttonExecutionLimitReached',
  ButtonConditionsNotMet = 'buttonConditionsNotMet',
  Conflict = 'conflict',
}
